import PlaylistData from "../playlist/data/PlaylistData";
import { PlaylistLocalStoragePersistence } from "../localStoragePersistence/v4/playlist/PlaylistLocalStoragePersistence";
import PlaylistMapper from "../playlist/mapper/PlaylistMapper";
import { sortBy } from "../helper/orderBy";

const playlistMapper = new PlaylistMapper();

export class PlaylistIndexLoader {
  public loadAll(
    currentCrewIdentifier: string | undefined,
  ): ReadonlyArray<PlaylistData> {
    const p = new PlaylistLocalStoragePersistence();
    return p
      .loadAll()
      .map((dto) => playlistMapper.persistedToDataMapper()(dto))
      .filter((playlist) => playlist.belongsToCrew === currentCrewIdentifier);
  }

  public orderBy(
    playlistIndex: ReadonlyArray<PlaylistData>,
    field: keyof PlaylistData,
    ascOrDesc: "asc" | "desc",
  ): ReadonlyArray<PlaylistData> {
    console.debug(
      "Order playlist index by newField=" +
        field +
        " newAscOrDesc=" +
        ascOrDesc,
    );
    return sortBy(playlistIndex, field, ascOrDesc);
  }
}
